import logo from "./applogo.png";
import AppleLogo from "../src/assets/appleLogo.png";
import googlePlayStore from "../src/assets/googlePlayStore.png";
import "./App.css";
import Contactus from "./Contactus";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} alt="logo" style={{ width: 400, marginTop: "-80px" }} />
        <h4
          style={{
            padding: "0px 3rem",
            marginTop: "-80px",
            lineHeight: 1.7,
            fontWeight: 300,
          }}
        >
          Welcome to <b>MyCollegeBook</b> the first and only Used College Textbook
          Market where you meet on Campus.<br/>Join Us Now to buy cheaper books and
          to get more money for your books.
        </h4>
        <div style={{fontWeight:600, fontSize:'1.2rem', marginBottom:'17px', marginTop:'18px'}}>Download the app on</div>
        <div>
          <a href="https://apps.apple.com/in/app/mycollegebook/id6466304611" target="_blank" class="animated-button1">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <div style={{ display: "flex" }}>
              <img src={AppleLogo} style={{ width: "30px" }} />
              <div
                style={{ color: "white", fontSize: "20px", marginLeft: "10px" }}
              >
                App Store
              </div>
            </div>
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.mohitviionn.mycollegebook&hl=en" target="_blank" class="animated-button1" >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <div style={{ display: "flex" }}>
              <img src={googlePlayStore} style={{ width: "30px" }} />
              <div
                style={{ color: "white", fontSize: "20px", marginLeft: "10px" }}
              >
                Play Store
              </div>
            </div>
          </a>
        </div>
      </header>
     </div>
  );
}

export default App;
